<template>
  <div style="height: 95vh !important"></div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      user: {},
      authorizationCode: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      urlapi: process.env.VUE_APP_APIURL,
      imgSwalErr: require("@/assets/images/ic_swal_error_reject.png"),
    };
  },
  created() {
    try {
      console.log(this.$route);
      this.initDataCallFromNext();
    } catch (error) {
      this.handdleError(error);
    }

  },
  methods: {
    initDataCallFromNext() {
      this.authorizationCode = this.$route.query.authorizationCode;
      //Get data by token
      this.$http({
        method: "POST",
        url: this.urlapi + "api/verifyToken",
        data: {
          authorizationCode: this.authorizationCode
        },
        timeout: this.timeout,
      })
        .then((response) => {
          this.mappingDataResponse(response);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    mappingDataResponse(response) {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf("android") > -1;
      if (response.data && response.data.status) {
        this.user.cif = response.data.cifNumber;
        this.user.creditLimit = Number(response.data.reqCreditLimit);
        this.user.documentType = response.data.documentType;
        this.user.historyUploads = response.data.checkListDocUploads;
        this.user.followupStatus = response.data.followupStatus;
        this.user.fullName = response.data.fullName;
        this.user.expiredDate = response.data.expiredDate;
        this.user.expireDay = response.data.expireDay;
        this.user.showDStatement = response.data.showDStatement;
        this.user.showDStatementErrorMsg = response.data.showDStatementErrorMsg;
        this.user.lstPriceAs = response.data.lstPriceAs;
        this.user.isAndroid = isAndroid;
        this.user.loanAppId = response.data.loanAppId;
        this.user.productName = response.data.paramDesc;
        this.user.productType = response.data.productType;
        this.user.haveListAccount = response.data.haveAccountList;
        this.user.marketCode = response.data.marketCode;
        this.user.periodStatementKtb = response.data.periodStatementKtb;
        this.user.periodStatementOtherBanks = response.data.periodStatementOtherBanks;
        this.user.otherBankHistory = response.data.otherBankHistory;
        this.user.monthCalc = response.data.monthCalc;
        this.user.isDocumentType = ["PENDING", "SUBMITED", "RESUBMIT"].includes(
          response.data.followupStatus.code
        );
        this.user.token = response.data.uuid;
        this.user.channel =
          response.data.channel &&
          "PT" == response.data.channel.toString().toUpperCase()
            ? "Paotang"
            : "NEXT";
        this.user.document_group_type = response.data.documentTypeGroup;
        this.user.document_group_type.forEach((v) => {
          v.progress = 0;
          let arry = this.user.documentType.filter(
            (docType) =>
              v.lst_doc_id.includes(docType.doc_code) && docType.doc_is_uploads
          );
          v.state = "wait";
          if (arry.length === v.lst_doc_id.length) v.state = "success";
        });
        this.user.documentType.forEach((i) => {
          i.filesReal = [];
          i.state = "wait";
          if (i.doc_is_uploads) i.state = "success";
        });
        this.setRoutePath();
        this.$store.dispatch("setUserData", this.user);
        this.$router.push("/landing");
      }
    },
    setRoutePath() {
      this.user.routerPath = {
        landing: "MainPage",
        login: "LoginPage",
        upload: "UploadPage",
        summary: "SummaryPage",
        documentGroup: "DocumentGroupPage",
        listAccount: "ListAccountPage",
        dStatement: "DstatementPage",
        uploadOtherBanks: "UploadOtherBanksPage",
        uploadOtherBank: "UploadOtherBankPage",
      };
    },
    handdleError(error) {
      console.log(error);
      if (error.response) {
        if (
          error.response.data != undefined &&
          error.response.data.code != undefined
        ) {
          this.getAlertNew(error.response.data.code);
        } else {
          this.getAlertNew(error.response.status);
        }
      } else {
        this.getAlertNew("9999");
      }
    },
    getAlertNew(code) {
      let title = null;
      let detail = null;
      let appIsExpired = false;
      let exitEntryPoint = false;
      let goToLFMStatusPage = false;
      switch (code) {
        case "2001":
          (title = "จำนวนเอกสารไม่ครบเงื่อนไขในการสมัคร"),
            (detail = "กรุณาตรวจสอบเอกสารประกอบการสมัครอีกครั้ง");
          break;
        case "4001":
          title = "ท่านทำรายการไม่ถูกต้อง";
          detail = "กรุณาทำรายการใหม่อีกครั้ง";
          break;
        case "4005":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        case "4006":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "4007":
          title = "ใบสมัครถูกยกเลิก";
          detail =
            "เนื่องจากคุณทำรายการเกินเวลาที่กำหนด คุณสามารถสมัครสินเชื่อได้อีกครั้งผ่านแอปฯ เป๋าตัง หรือ Krungthai NEXT ขอขอบคุณในความไว้วางใจ และหวังเป็นอย่างยิ่งว่าจะได้ให้บริการคุณในโอกาสต่อไป";
          appIsExpired = true;
          break;
        case "4009":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          goToLFMStatusPage = true;
          break;
        case "5007":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "5008":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง(1)";
          exitEntryPoint = true;
          break;
        case "5009":
          title = "ไม่สามารถทำรายการได้ในขณะนี้";
          detail =
            "กรุณาลองใหม่อีกครั้งในภายหลัง";
          exitEntryPoint = true;
          break;
        default:
          title = "ไม่สามารถทำรายการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้งในภายหลัง";
          exitEntryPoint = true;
      }
      if (appIsExpired) {
        this.showAlertThenExitEntryPointIOS(
          this.imgSwalErr,
          title,
          detail,
          "สถานะการสมัคร"
        );
      } else if (exitEntryPoint) {
        this.showAlertThenExitEntryPointIOS(
          this.imgSwalErr,
          title,
          detail,
          "อัปโหลดเอกสาร"
        );
      } else if (goToLFMStatusPage) {
        this.showAlertThenGotoStatusPages(
          this.imgSwalErr,
          title,
          detail,
          "อัปโหลดเอกสาร"
        );
      }
    },
    getHeight() {
      var h = window.innerHeight;
      if (h == 0) h = 650;
      return window.innerHeight - 45;
    },
    showAlertThenGotoStatusPages(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              this.$callback.exitEntryPoint();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
    showAlertThenExitEntryPointIOS(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              this.$callback.exitEntryPoint();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
  },
};
</script>

<style>
.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 40vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}
.swal2-image-next-fullscreen {
  margin-top: 0vh !important;
  margin-bottom: 0vh !important;
}
.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}
.swal2-icon-content {
  margin: 0;
  font-family: Kanit-Bold;
  font-size: 20px !important;
  line-height: 24px !important;
  color: #212121 !important;
}
.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}
.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}
</style>
